export const toEuro = (val:number) => {
  return `${val.toFixed(2)} €`;
}